import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../utils/translations';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {Alert, AlertSuccess} from '@homeaway/react-alerts';
import {ALERT__24} from '@homeaway/svg-defs/lib/defs/ALERT__24';
import {SVGIcon} from '@homeaway/react-svg';
import edap from '@homeaway/edap-wrapper';
import request from 'superagent';

export class EmailConfirmation extends React.Component {
    static propTypes = {
        systemData: PropTypes.shape({}),
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        systemData: {},
        translations: {},
    };

    state = {
        sentStatus: 'none',
    };

    sendConfirmationEmail = () => {
        this.setState({sentStatus: 'none'});

        request
            .post('/bizops/travelerHome/confirmEmail')
            .set('Content-Type', 'application/json')
            .set('X-HomeAway-Restfully', true)
            .send({
                brandId: this.props.systemData.site?.brandId,
                target: window.location.href,
            })
            .on('error', this.onConfirmationError)
            .then(this.onConfirmationSuccess);
    };

    onConfirmationSuccess = () => {
        this.setState({sentStatus: 'success'});

        edap().push({
            name: 'generic.event',
            data: {
                eventcategory: 'traveler activity',
                eventaction: 'confirmation email sent',
            },
        });
    };

    onConfirmationError = () => {
        this.setState({sentStatus: 'failure'});

        edap().push({
            name: 'generic.error',
            data: {
                logmessage: 'th error sending confirmation email',
            },
        });
    };

    render() {
        const {translations} = this.props;

        return (
            <div className="EmailConfirmation text-center">
                {this.state.sentStatus === 'failure' && (
                    <Alert
                        msg={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.empty.unconfirmed.error'
                        )}
                        title={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.alert.status.retry'
                        )}
                    />
                )}
                {this.state.sentStatus === 'success' && (
                    <AlertSuccess
                        msg={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.empty.unconfirmed.success'
                        )}
                        title={''}
                    />
                )}
                <span className="text-brand">
                    <SVGIcon markup={ALERT__24} useFill />
                </span>
                <p>
                    <strong>
                        {translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.empty.unconfirmed.title'
                        )}
                    </strong>
                </p>
                <p>
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.inbox.empty.unconfirmed.message'
                    )}
                </p>
                <ButtonPrimary
                    className={'btn--nowrap'}
                    label={translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.inbox.empty.unconfirmed.link'
                    )}
                    onClick={this.sendConfirmationEmail}
                />
            </div>
        );
    }
}
